module.exports = __webpack_public_path__ + "img/banner.4abac950.png";